/* WN Sale countdown (28 Oct 2026). Reads window.WN_SALE, set by sections/wn-sale-bar.liquid.
   - [data-wn-cd="boxes"] with [data-u="d|h|m|s"] children: big countdown boxes
   - [data-wn-cd="short"]: one-line "18d 06h 12m 05s"
   - [data-wn-sale-name] / [data-wn-sale-end]: sale name / end date text
   When the end date passes, <html> loses .wn-sale-on, so every [data-wn-sale] element hides (see assets/wn-sale.css).
   The same end date counts down for every visitor; it never resets. */
(function(){
  var S=window.WN_SALE;
  if(!S||!S.on)return;
  var root=document.documentElement,timer=0;
  function pad(n){return (n<10?'0':'')+n;}
  function texts(){
    document.querySelectorAll('[data-wn-sale-name]').forEach(function(el){if(S.name&&el.textContent!==S.name)el.textContent=S.name;});
    document.querySelectorAll('[data-wn-sale-end]').forEach(function(el){if(S.endLabel&&el.textContent!==S.endLabel)el.textContent=S.endLabel;});
  }
  function tick(){
    var ms=S.end-Date.now();
    if(!(ms>0)){
      root.classList.remove('wn-sale-on');root.classList.add('wn-sale-off');
      clearInterval(timer);return;
    }
    var s=Math.floor(ms/1000),d=Math.floor(s/86400),h=Math.floor(s%86400/3600),m=Math.floor(s%3600/60),x=s%60;
    var v={d:pad(d),h:pad(h),m:pad(m),s:pad(x)};
    document.querySelectorAll('[data-wn-cd="boxes"] [data-u]').forEach(function(el){var t=v[el.getAttribute('data-u')];if(t&&el.textContent!==t)el.textContent=t;});
    var short=(d>0?d+'d ':'')+pad(h)+'h '+pad(m)+'m '+pad(x)+'s';
    document.querySelectorAll('[data-wn-cd="short"]').forEach(function(el){if(el.textContent!==short)el.textContent=short;});
  }
  function start(){texts();tick();timer=setInterval(function(){tick();},1000);setTimeout(texts,1500);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();
